import { styled } from '@/shared/styles/theme'
import { Text } from '@/shared/ui/Typography'

export const CalloutRoot = styled('div', {
  display: 'flex',
  alignItems: 'flex-start',
  gap: '$2',
  padding: '$3',
  borderRadius: '$sm',
  width: '100%',
  textWrap: 'balance',

  variants: {
    variant: {
      info: {
        backgroundColor: '$white',
        border: '1px solid $info70',
        color: '$info10',
        [`& ${Text}`]: {
          color: '$info10',
        },
      },
    },
  },
  defaultVariants: {
    variant: 'info',
  },
})

export const CalloutIcon = styled('div', {
  flexShrink: 0,
})

export const CalloutContent = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  gap: '$1',
  flex: 1,
})
